// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1-POZ","right":"Footer_right__2kVP4","buttons":"Footer_buttons__2uC8p"};